/**
 * 外卖商家出佣页埋点
 */

export const PAGE_CID = 'c_waimai_btlxu2v1'

// 导航栏埋点值
export const NAVIGATION_HEADER_BID_MV = {
  LOCATION: 'b_waimai_n6xzkxw1_mv', // 定位入口
}

// 导航栏点击埋点值
export const NAVIGATION_HEADER_BID_MC = {
  LOCATION: 'b_waimai_n6xzkxw1_mc', // 定位入口
}

export const TABBAR_BID_MV = {
  TAB: 'b_waimai_dq2fw1nq_mv', // 标签栏Tab
  QUICK_SELECTION: 'b_waimai_3bj9kzlw_mv', // 快筛
}

export const TABBAR_BID_MC = {
  TAB: 'b_waimai_dq2fw1nq_mc', // 标签栏Tab
  QUICK_SELECTION: 'b_waimai_3bj9kzlw_mc', // 快筛
}

export const POI_CARD_BID_MV = {
  CARD: 'b_waimai_9romzu0c_mv', // 外卖商菜卡片
  SKU: 'b_waimai_e9ec2zad_mv', // 下挂菜
  COUPON: 'b_waimai_52ydf57s_mv', // 下挂券
}

export const POI_CARD_BID_MC = {
  CARD: 'b_waimai_9romzu0c_mc', // 外卖商菜卡片
  SKU: 'b_waimai_e9ec2zad_mc', // 下挂菜
  COUPON: 'b_waimai_52ydf57s_mc', // 下挂券
}

export const LX_CONFIG = {
  NAVIGATION_HEADER_BID_MV,
  NAVIGATION_HEADER_BID_MC,
  TABBAR_BID_MV,
  TABBAR_BID_MC,
  POI_CARD_BID_MV,
  POI_CARD_BID_MC,
}
